<template>
  <div class="wrapper clickable" @click="displayMedia(true)">
    <img :src="thumbnail" class="cover" fluid/>
    <div class="icon">
      <i class="fas fa-play fa-3x"></i>
    </div>

    <b-modal v-model="showModal"
             :title="model.name"
             centered
             size="lg"
             hide-footer 
             no-close-on-backdrop>

      <div class="embed-responsive embed-responsive-16by9">
        <video id="modalVideo" ref="modalVideo" controls="false">
          <source :src="model.url" />
        </video>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: null, default: '' }
  },
  data() {
    return {
      showModal: false
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(model) {
        this.$emit('input', model)
      }
    },
    thumbnail(){
      return this.model.thumbnail? this.model.thumbnail.url: this.model.url
    }
  },
  watch: {
    model(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.model = val
    },
    showModal: function (val) {
      if (!val) {
        this.$refs.modalVideo.pause()
        this.$refs.modalVideo.currentTime = 0
      }
    }
  },
  methods: {
    displayMedia(show) {
      this.showModal = show
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

.wrapper {
  height: 8rem;
  width: 15rem;
  position: relative;
  overflow: hidden;
  margin-right: $spacing-sm;
  flex: 0 0 auto;
  justify-content:center;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

div.wrapper img {
  position: relative;
  top: -1px;
  left: -1px;
}

.cover {
  object-fit: fill;
  width: 15rem;
  height: 8rem;
}

.icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate( -50%, -50% );
  z-index: 500;
  color: $medium-grey;
}
</style>


// WEBPACK FOOTER //
// src/components/common/media/video-preview.vue